import styled from 'styled-components';
import Link from 'next/link';

import { config } from '_config';
import { ROUTES } from '_constants/routes';
import { theme } from '_constants/theme';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${theme.colors.white};
`;

const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;

  position: relative;
  overflow: hidden;

  max-width: ${theme.spaces.large30X * 10}px;
  width: 100%;

  padding-top: ${theme.spaces.large19X}px;
  padding-bottom: ${theme.spaces.large19X}px;
  padding-left: ${theme.spaces.large28X - 1}px;
  padding-right: ${theme.spaces.large28X - 1}px;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
    padding-top: ${theme.spaces.large8X}px;
    padding-bottom: ${theme.spaces.large8X}px;
  }
`;

const StyledTitle = styled.div`
  padding-right: 30%;
  margin-bottom: ${theme.spaces.large}px;
  font-family: 'Inter';
  font-size: ${theme.fontSizes.large8X}px;
  font-weight: 600;
  line-height: 39.6px;
  letter-spacing: -0.03em;
  text-align: left;
  background: linear-gradient(270.46deg, #101828 47.44%, #6941c6 102.37%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media ${theme.devices.tablet} {
    width: 100%;
    padding-right: unset;
    font-size: ${theme.fontSizes.large4X}px;
    line-height: 30.8px;
    text-align: center;
  }
`;

const StyledText = styled.div`
  font-family: 'Inter';
  font-size: ${theme.fontSizes.large}px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.03em;
  text-align: left;
  color: ${theme.colors.gray.secondary};

  @media ${theme.devices.tablet} {
    font-size: ${theme.fontSizes.medium}px;
    line-height: 27px;
  }
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 300px;
  width: calc(25% - 3 * 30px / 4);

  @media ${theme.devices.tablet} {
    align-items: center;
    height: auto;
    width: 100%;
  }
`;

const StyledCardContainer = styled.div`
  position: relative;
  width: calc(25% - 3 * 30px / 4);
  padding-bottom: ${theme.spaces.large}px;

  @media ${theme.devices.tablet} {
    width: 100%;
  }
`;

const StyledCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 300px;
  width: 100%;
  border-radius: 10px;
  z-index: 0;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;

  a {
    text-decoration: none;
  }
`;

const StyledCardTitle = styled.div`
  font-family: 'Inter';
  font-size: ${theme.fontSizes.medium}px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.03em;
  text-align: left;
  color: ${theme.colors.white};

  &:hover {
    text-decoration: underline;
  }
`;

const StyledBackgroundImageContainer = styled.div`
  position: absolute;
  width: 362px;
  z-index: -1;
  transition: all 0.3s linear;

  img {
    width: 100%;
  }

  &:hover {
    transform: scale(1.5);
  }
`;

const StyledCardTailContainer = styled.div`
  position: absolute;
  top: 200px;
  left: 10px;
  right: 10px;

  img {
    height: 118px;
    width: 100%;
  }
`;

const SelectServiceSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <StyledHeaderContainer>
          <StyledTitle>Ready to partner with us?</StyledTitle>
          <StyledText>Select a service you need</StyledText>
        </StyledHeaderContainer>
        <StyledCardContainer>
          <StyledCard>
            <Link href={ROUTES.bookkeeping}>
              <StyledCardTitle>Bookkeeping</StyledCardTitle>
            </Link>
            <StyledBackgroundImageContainer>
              <picture>
                <source
                  srcSet={`${config.basePath}/images/bookkeeping-service.png`}
                  type="image/png"
                />
                <img
                  src={`${config.basePath}/images/bookkeeping-service.png`}
                  alt=""
                />
              </picture>
            </StyledBackgroundImageContainer>
          </StyledCard>
          <StyledCardTailContainer>
            <picture>
              <source
                srcSet={`${config.basePath}/images/gradient-tail.png`}
                type="image/png"
              />
              <img src={`${config.basePath}/images/gradient-tail.png`} alt="" />
            </picture>
          </StyledCardTailContainer>
        </StyledCardContainer>
        <StyledCardContainer>
          <StyledCard>
            <Link href={ROUTES.taxPreparation}>
              <StyledCardTitle>Tax Preparation</StyledCardTitle>
            </Link>
            <StyledBackgroundImageContainer>
              <picture>
                <source
                  srcSet={`${config.basePath}/images/tax-preparation-service.png`}
                  type="image/png"
                />
                <img
                  src={`${config.basePath}/images/tax-preparation-service.png`}
                  alt=""
                />
              </picture>
            </StyledBackgroundImageContainer>
          </StyledCard>
          <StyledCardTailContainer>
            <picture>
              <source
                srcSet={`${config.basePath}/images/gradient-tail.png`}
                type="image/png"
              />
              <img src={`${config.basePath}/images/gradient-tail.png`} alt="" />
            </picture>
          </StyledCardTailContainer>
        </StyledCardContainer>
        <StyledCardContainer>
          <StyledCard>
            <Link href={ROUTES.about}>
              <StyledCardTitle>Payroll</StyledCardTitle>
            </Link>
            <StyledBackgroundImageContainer>
              <picture>
                <source
                  srcSet={`${config.basePath}/images/payroll-service.png`}
                  type="image/png"
                />
                <img
                  src={`${config.basePath}/images/payroll-service.png`}
                  alt=""
                />
              </picture>
            </StyledBackgroundImageContainer>
          </StyledCard>
          <StyledCardTailContainer>
            <picture>
              <source
                srcSet={`${config.basePath}/images/gradient-tail.png`}
                type="image/png"
              />
              <img src={`${config.basePath}/images/gradient-tail.png`} alt="" />
            </picture>
          </StyledCardTailContainer>
        </StyledCardContainer>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default SelectServiceSection;
